import Section from './Section';

function Trailer({ trailer }) {
  return (
    <Section id="trailer" title={trailer.title} subtitle={trailer.description}>
      <div className="trailer-frame" role="region" aria-label="Trailer placeholder">
        {trailer.trailerUrl ? (
          <img className="trailer-video" src={trailer.trailerUrl} alt="Game trailer preview" />
        ) : (
          <div className="media-placeholder video video-poster">
            <button type="button" className="play-button" aria-label="Play trailer placeholder">
              Play
            </button>
            <span>Trailer coming soon</span>
          </div>
        )}
      </div>
    </Section>
  );
}

export default Trailer;
